import React from 'react';
import {NavigationContainer} from '@react-navigation/native';
import {Provider} from 'react-redux';
import {SafeAreaProvider} from 'react-native-safe-area-context';
import {store} from 'store';
import Navi from './Navi';
import LinkingConfiguration from './LinkingConfiguration';

function AppContainer() {
  // useEffect(() => {
  //   handleNotification();
  //   return () => {};
  // }, []);

  return (
    <SafeAreaProvider>
      <Provider store={store}>
        <NavigationContainer linking={LinkingConfiguration} independent={true}>
          <Navi />
        </NavigationContainer>
      </Provider>
    </SafeAreaProvider>
  );
}

export default React.memo(AppContainer);
